module.exports = __webpack_public_path__ + "static/media/lag-baomer.94b06f60.svg";